import { SPECIES } from '../data/GameData';

// Backgrounds
import petriDishImg from '../assets/backgrounds/petri-dish.png';
import menuBgImg from '../assets/backgrounds/menu-bg.png';
import gameBgImg from '../assets/backgrounds/game-bg.png';
import speciesBgImg from '../assets/backgrounds/species-bg.png';
import diffBgImg from '../assets/backgrounds/diff-bg.png';

// UI
import heroDishImg from '../assets/ui/hero-dish.png';
import titleImg from '../assets/ui/title.png';
import btnOpenFieldImg from '../assets/ui/btn-open-field.png';
import btnChokepointImg from '../assets/ui/btn-chokepoint.png';
import btnRingImg from '../assets/ui/btn-ring.png';
import difficultyBoxImg from '../assets/ui/difficulty-box.png';
import btnEasyImg from '../assets/ui/btn-easy.png';
import btnNormalImg from '../assets/ui/btn-normal.png';
import btnHardImg from '../assets/ui/btn-hard.png';
import btnInsaneImg from '../assets/ui/btn-insane.png';
import btnBackImg from '../assets/ui/btn-back.png';
import btnSpeciesImg from '../assets/ui/btn-species.png';

// Species Sprites
import penicilliumStage1 from '../assets/species/penicillan/1.png';
import penicilliumStage2 from '../assets/species/penicillan/2.png';
import penicilliumStage3 from '../assets/species/penicillan/3.png';

import rhizopusStage1 from '../assets/species/rhizopus/1.png';
import rhizopusStage2 from '../assets/species/rhizopus/2.png';
import rhizopusStage3 from '../assets/species/rhizopus/3.png';

import aspergillusStage1 from '../assets/species/aspergillus/1.png';
import aspergillusStage2 from '../assets/species/aspergillus/2.png';
import aspergillusStage3 from '../assets/species/aspergillus/3.png';

import candidaStage1 from '../assets/species/candida/1.png';
import candidaStage2 from '../assets/species/candida/2.png';
import candidaStage3 from '../assets/species/candida/3.png';

import trichodermaStage1 from '../assets/species/trichoderma/1.png';
import trichodermaStage2 from '../assets/species/trichoderma/2.png';
import trichodermaStage3 from '../assets/species/trichoderma/3.png';

import mucorStage1 from '../assets/species/mucor/1.png';
import mucorStage2 from '../assets/species/mucor/2.png';
import mucorStage3 from '../assets/species/mucor/3.png';

import cordycepsStage1 from '../assets/species/cordyceps/1.png';
import cordycepsStage2 from '../assets/species/cordyceps/2.png';
import cordycepsStage3 from '../assets/species/cordyceps/3.png';

import stachybotrysStage1 from '../assets/species/stachybotrys/1.png';
import stachybotrysStage2 from '../assets/species/stachybotrys/2.png';
import stachybotrysStage3 from '../assets/species/stachybotrys/3.png';

// Export UI Images for direct use
export const UI_IMAGES = {
  menuBg: menuBgImg,
  gameBg: gameBgImg,
  speciesBg: speciesBgImg,
  diffBg: diffBgImg,
  heroDish: heroDishImg,
  title: titleImg,
  difficultyBox: difficultyBoxImg,
  buttons: {
    openField: btnOpenFieldImg,
    chokepoint: btnChokepointImg,
    ring: btnRingImg,
    easy: btnEasyImg,
    normal: btnNormalImg,
    hard: btnHardImg,
    insane: btnInsaneImg,
    back: btnBackImg,
    species: btnSpeciesImg,
  }
};

export const BACKGROUND_IMAGE = petriDishImg;

export const getSpeciesImage = (speciesId, biomass) => {
  let stage1, stage2, stage3;

  switch (speciesId) {
    case 'penicillium':
      stage1 = penicilliumStage1; stage2 = penicilliumStage2; stage3 = penicilliumStage3;
      break;
    case 'rhizopus':
      stage1 = rhizopusStage1; stage2 = rhizopusStage2; stage3 = rhizopusStage3;
      break;
    case 'aspergillus':
      stage1 = aspergillusStage1; stage2 = aspergillusStage2; stage3 = aspergillusStage3;
      break;
    case 'candida':
      stage1 = candidaStage1; stage2 = candidaStage2; stage3 = candidaStage3;
      break;
    case 'mucor':
      stage1 = mucorStage1; stage2 = mucorStage2; stage3 = mucorStage3;
      break;
    case 'cordyceps':
      stage1 = cordycepsStage1; stage2 = cordycepsStage2; stage3 = cordycepsStage3;
      break;
    case 'stachybotrys':
      stage1 = stachybotrysStage1; stage2 = stachybotrysStage2; stage3 = stachybotrysStage3;
      break;
    case 'trichoderma':
      stage1 = trichodermaStage1; stage2 = trichodermaStage2; stage3 = trichodermaStage3;
      break;
    default:
      return null;
  }

  if (biomass >= 8) return stage3;
  if (biomass >= 4) return stage2;
  return stage1;
};

export const getSpeciesColor = (speciesId, alpha = 0.7) => {
  const species = SPECIES[speciesId];
  if (!species) return `rgba(180, 180, 170, ${alpha})`;
  return species.color.replace('ALPHA', alpha.toString());
};